import {useHistory} from 'react-router-dom';
import "../home/home.css";
import 'firebase/firestore';
import Header from '../home/header/header';
import './upload-successful.css'
import textlogo from "../../static/textlogo.png";
import checklogo from "../../static/checkmarkLogo.png";
import Sider from "./form-menu";
import React from "react";
import {Auth, db} from "../../index";

const UploadSuccess = ({signedIn, setSignedIn}) => {
    const history = useHistory()

    const handleLogOut = () => {
        Auth.signOut();
        setSignedIn(false)
        history.push("/home")
    }

    const handleBackHome = () => {
        history.push("/home")
    }

    return (
        <>
            <div className="header-box">
                <Header signedIn={signedIn} handleLogOut={handleLogOut}/>
            </div>
            <div className="upload-container">
                <div id="upload-left-container">
                    <img id="ontheupload" src={textlogo} alt="HuaPsych"/>
                    <Sider/>
                </div>
                <div className="right-success-container">
                    <img id="checkMark" src={checklogo} alt="checkmark"/>
                    <h1>All set!</h1>
                    <p>You’ve successfully uploaded your survey.
                        It’s now under review. We will notify you as soon as the admin approves.
                        <br />
                        <br />
                        Thanks for trusting us and using our survey platform.</p>
                    <button onClick={handleBackHome}>Return to homepage</button>
                </div>
            </div>

        </>
    );
}

export default UploadSuccess;